import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';

interface MesoAdsenseCsaProps {
  query: string;
}

interface MesoCsaSlotProps {
  type?: string;
  container: string;
  width: string;
}

export const MesoAdsenseCsa: React.FunctionComponent<MesoAdsenseCsaProps> = props => (
  <ErrorBoundary label="meso.adsense.csa">
    <meso-adsense-csa class="ad-div uitk-cell" {...props} />
  </ErrorBoundary>
);

export const MesoCsaSlot: React.FunctionComponent<MesoCsaSlotProps> = props => (
  <ErrorBoundary label="meso.csa.slot">
    <meso-csa-slot class="ad-div uitk-cell" {...props} />
  </ErrorBoundary>
);
